import React, { useEffect, useState } from 'react';
import { Divider,Spin, Tooltip } from 'antd';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { findIndex, isNaN, sumBy } from 'lodash';
import moment from 'moment';

import LeftArrow from '../../../../../../../assets/icons/arrow-left-blue.svg';
import Amazon from '../../../../../../../assets/icons/amazon-link-logo.svg';
import DeleteIcon from '../../../../../../../assets/icons/delete-border-icon.svg';
import ProductImage from '../../../../../../../assets/icons/product-image.svg';
import Button from "../../../../../../../components/uiComponent/button/index";
import Input from "../../../../../../../components/uiComponent/inputs/input/index"
import Modal from "../../../../../../../components/uiComponent/modal/index"

import { DrawerStyleWrapper } from '../../style'
import { CreateSingleSkuBox, GetWarehouseShipments } from '../../../../../../../slices/post-shipment';
import productLabel from '../../../../../../../utils/print-labels/productLabel';
import box2DLabels from '../../../../../../../utils/print-labels/box2DLabels';
import { mix2DLablePdfSinglePage } from '../../../../../../../actions/utils/mix2DLablePdf';
import { getNewBoxIndex } from '../../../../../../../utils/get-box-index';

const initialBoxDetails = { noOfBoxes: 0, inABox: 0 };

const AddItemDrawer = ({
  setProductInfo,
  productInfo,
  itemsList,
  itemShipmentIndex,
  setItemShipmentIndex,
  itemShipments,
  setItemShipments,
  itemIndex,
  clearSearch,
  setItemIndex,
  boxesList,
  productDetail,
  setProductDetail
}) => {
  const { workOrderId } = useParams();
  const dispatch = useDispatch();

  const [boxesDetail, setBoxesDetail] = useState([{ ...initialBoxDetails }]);
    const {
    shipmentDetails,
    creatingSingleSkuBox
  } = useSelector((state) => state.postShipment || {});

  const addRow = () => {
    setBoxesDetail(boxesDetail => [...boxesDetail, { ...initialBoxDetails }]);
  };

  const [fnskuLabels, setFnskuLabels] = useState(0);

  const handlePrintFnskuLabels = () => {
    const {
      item_name,
      prep_instructions,
      expiration,
      fnsku,
      min_bundle_quantity: bundleQty
    } = productDetail || {};

    const labelsData = {
      fnsku,
      title: item_name || '',
      expiryDate: expiration ? moment(expiration).format('MM-DD-YYYY') : 'N/A',
      bundleQty,
      numberOfLabels: Number(fnskuLabels),
      username: "Opulent",
      prepInstruction: prep_instructions,
    };

    productLabel(labelsData);
  }


  const removeRow = (index) => {
    setBoxesDetail(boxesDetail => {
      const updatedBoxes = [...boxesDetail];
      updatedBoxes.splice(index, 1);
      return updatedBoxes;
    });
  };

  const handleGenerateProductLabels = () => {
    const numberOfLabels = getTotalQuantity();
    const {
      item_name,
      prep_instructions,
      expiration,
      fnsku,
      min_bundle_quantity: bundleQty
    } = productDetail || {};

    const labelsData = {
      fnsku,
      title: item_name || '',
      expiryDate: expiration ? moment(expiration).format('MM-DD-YYYY') : 'N/A',
      bundleQty,
      numberOfLabels,
      username: "Opulent",
      prepInstruction: prep_instructions,
    };

    productLabel(labelsData);
  };

  const handleGenerate2DBoxLabel = () => {
    const {
      amazon_shipment_confirmation_id: shipmentId,
      name: shipmentName
    } = itemShipments[itemShipmentIndex] || {};
    const {
      fnsku: fulfillmentNetworkSku
    } = productDetail || {};

    const boxesExpanded = boxesDetail.flatMap(({ noOfBoxes, inABox }) =>
      Array.from({ length: noOfBoxes }, () => inABox)
    );

    boxesExpanded.forEach(units => {
      const box = {
        shipmentId,
        shipmentName,
        userName: 'Opulent',
        items: [{ units, fulfillmentNetworkSku }]
      };

      box2DLabels(box);
    });
  };

  const handleGenerateMix2DBoxLabel = (shipmentDetails = [], boxesToPrint) => {
    const {
      amazon_shipment_confirmation_id: shipmentId,
      name: shipmentName,
      amazon_shipment_id,

      amazon_warehouse_id: FCID,
      destination_name,
      destination_city,
      destination_country_code,
      destination_postal_code,
      destination_address_line_1,
      destination_state_or_province_code,

      source_city,
      source_country_code,
      source_postal_code,
      source_name,
      source_address_line_1,
    } = itemShipments[itemShipmentIndex] || {};
    const {
      fnsku,
      expiration,
      item_name,
    } = productDetail || {};

    const boxesExpanded = boxesDetail.flatMap(({ noOfBoxes, inABox }) =>
      Array.from({ length: noOfBoxes }, () => inABox)
    );

    let exp = null;
    if (expiration) {
      exp = moment(expiration, "YYYY-MM-DD").format("YYMMDD");
    }

    const ship = {
      warehouse_name: source_name,
      address_line1: source_address_line_1,
      city: source_city,
      state_or_province_code: source_postal_code,
      country_code: source_country_code,

      ship_to_name: destination_name,
      destination_fulfillment_center_id: FCID,
      ship_to_address1: destination_address_line_1,
      ship_to_city: destination_city,
      ship_to_state: destination_state_or_province_code,
      ship_to_postal_code: destination_postal_code
    };

    const shipment = shipmentDetails?.shipments?.find(
      s => s.amazon_shipment_id === amazon_shipment_id
    );
    
    const boxesList = shipment?.boxes_info?.reduce((acc, box, index) => {
      if (boxesToPrint.includes(box.id)) {
        acc.push({ ...box, index: index + 1 });
      }
      return acc;
    }, []) || [];

    mix2DLablePdfSinglePage({
      shipmentId,
      userName: 'Opulent',
      shipmentName,
      dateCreated: moment().format("DD/MM/YY"),
      outbound_shipment_id: amazon_shipment_id,
      boxesExpanded: boxesList,
      title: fnsku,
      is2D: true,
      ship
    });
  };

  const getTotalQuantity = () => {
    const total = boxesDetail.reduce((sum, box) => {
      const noOfBoxes = Number(box.noOfBoxes) || 0;
      const inABox = Number(box.inABox) || 0;
      return sum + (noOfBoxes * inABox);
    }, 0);

    return total;
  };

  const handleSubmitBoxCreation = () => {
    const {
      sku_id
    } = productDetail || {};
    let boxIds = [];
    dispatch(CreateSingleSkuBox({
      sku_id,
      boxesDetail,
      amazonShipmentId: itemShipments[itemShipmentIndex]?.amazon_shipment_id,
      shipmentItemId: itemShipments[itemShipmentIndex]?.shipment_item_id || productDetail?.id, // product detail is used for single shipment case
      workOrderId: Number(workOrderId)
    }))
      .then(({ payload }) => {
        if (payload?.success) {
          // handleGenerateProductLabels();
          // handleGenerate2DBoxLabel();
          // clearSearch();
          boxIds = payload?.boxIds || [];
          const hasNonZeroRemainingQuantity = itemShipments
          .filter(shipment => Number(shipment.boxed_quantity || 0) !== Number(shipment.quantity || 0))
          .some((shipment) => {
            const remainingQuantity = Number(shipment?.quantity) - ((shipment.boxed_quantity || 0) + getTotalQuantity());
            return remainingQuantity !== 0;
          });

        if (!hasNonZeroRemainingQuantity) setProductInfo(false);
        else {
          setBoxesDetail([{ ...initialBoxDetails }]);
          setProductDetail((prev) => ({
            boxed_quantity: Number(prev?.boxed_quantity || 0) + getTotalQuantity(),
            ...prev
          }));
          setItemShipments(itemShipments => {
            const updatedShipments = [...itemShipments];
            updatedShipments[itemShipmentIndex] = {
              ...updatedShipments[itemShipmentIndex],
              boxed_quantity: Number(updatedShipments[itemShipmentIndex].boxed_quantity) + getTotalQuantity()
            };
            return updatedShipments;
          });
          
        }

          dispatch(GetWarehouseShipments({
            workOrderId,
          })).then(({ payload }) => {
            handleGenerateMix2DBoxLabel(payload?.shipmentDetails, boxIds);

          });
          // here
        }
      });
  };

  const getCreateBtnDisabledStatus = () => {
    if (creatingSingleSkuBox) return true;
    const totalQty = getTotalQuantity();

    const remainingQty = Number(itemShipments[itemShipmentIndex]?.quantity) - (itemShipments[itemShipmentIndex]?.boxed_quantity || 0);
    const hasInvalidQty = boxesDetail.some(box =>
      !box.noOfBoxes || !box.inABox ||
      isNaN(Number(box.noOfBoxes)) || isNaN(Number(box.inABox)) ||
      (Number(box.noOfBoxes) <= 0) || (Number(box.inABox) <= 0)
    );

    return (
      (itemShipmentIndex === -1) || !boxesDetail?.length || (totalQty > remainingQty) || hasInvalidQty
    );
  };

  const handleInputChange = (index, field, value) => {
    setBoxesDetail(boxesDetail => {
      const updatedBoxes = [...boxesDetail];
      updatedBoxes[index] = { ...updatedBoxes[index], [field]: value };
      return updatedBoxes;
    });
  };

  const handleCancel = () => {
    setProductInfo(false);
    setProductDetail({});
  }
  useEffect(() => {
    if (itemShipments?.length) {
      const currentShipment = itemShipments[itemShipmentIndex];
      const currentHasRemainingQty =
        Number(currentShipment?.quantity || 0) > Number(currentShipment?.boxed_quantity || 0);
  
      if (!currentHasRemainingQty) {
        const firstAvailableIndex = itemShipments.findIndex(
          shipment => Number(shipment.quantity || 0) > Number(shipment.boxed_quantity || 0)
        );
  
        if (firstAvailableIndex !== -1) {
          setItemShipmentIndex(firstAvailableIndex);
          setBoxesDetail([{ ...initialBoxDetails }]);
  
          const shipmentId = itemShipments[firstAvailableIndex]?.shipment_item_id;
          const matchedItemIndex = findIndex(itemsList, ({ id }) => id === shipmentId);
          setItemIndex(matchedItemIndex);
        }
      }
    }
  }, [itemShipments]);
 
  return (
    <Modal
      removeIcon={true}
      width={1012}
      closeable={true}
      onClose={() => {
        setProductInfo(false)
        setProductDetail({});
      }}
      open={productInfo}
      className="product-info-modal-wrapper"
      centered={true}
    >
        <DrawerStyleWrapper>
          <header />
          <div className='product-info-ui-wrapper'>
          <img src={productDetail?.image_url || ProductImage} alt="product-image" />
          <div className='content-drawer-product-info'>
          <div className='product-info-wrapper'>
            <div className='title'>
              <p>Title</p>
              <div className='title-item'>
                <p
                  style={{ cursor: 'pointer' }}
                  onClick={() => window.open(`https://www.amazon.com/gp/product/${productDetail?.asin}`, "_blank")}
                >
                  {productDetail?.item_name}
                </p>
                <img src={Amazon} alt="Amazon"
                  style={{ cursor: 'pointer' }}
                  onClick={() => window.open(`https://www.amazon.com/gp/product/${productDetail?.asin}`, "_blank")}
                />
              </div>
              <div className='units-wrapper'>
                <div className='units-items'>
                  <p>Total Qty</p>
                  <p>{
                    sumBy(
                      itemsList.filter(({ msku = '' }) => msku === productDetail?.msku),
                      (item) => Number(item.quantity)
                    )
                  }</p>
                </div>
                <div className='units-items'>
                  <p>Packed Qty</p>
                  <p>{sumBy(
                    itemsList.filter(({ msku = '' }) => msku === productDetail?.msku),
                    (item) => Number(item.boxed_quantity || 0)
                  )}</p>
                </div>
                <div className='units-items2 instruction-items2'>
                <p
                    style={{
                      fontWeight: 'bold',
                      color: 'red'
                    }}
                  >Bundle Qty</p>
                  <p 
                  style={{
                    color: 'red'
                  }}
                  >{productDetail?.min_bundle_quantity || '1'}</p>
                  </div>
                <div className='units-items'>
                  <p>Remaining Qty</p>
                  <p>{sumBy(
                    itemsList.filter(({ msku = '' }) => msku === productDetail?.msku),
                    (item) => Number(item.quantity)
                  ) - sumBy(
                    itemsList.filter(({ msku = '' }) => msku === productDetail?.msku),
                    (item) => Number(item.boxed_quantity || 0)
                  )}</p>
                </div>
                <div className='units-items instruction-items'>
                  <p>Prep instructions</p>
                  <p>{productDetail?.prep_instructions || 'N/A'}</p>
                </div>
              </div>
              <Divider />
              {/* <div className='instruction-wrapper'>
                <div className='instruction-items'>
                  <p>Prep instructions</p>
                  <p>{itemsList[itemIndex]?.prep_instructions || 'N/A'}</p>
                </div>
                <div className='instruction-items'>
                  <p
                    style={{
                      fontWeight: 'bold',
                      color: 'red'
                    }}
                  >Bundle Qty</p>
                  <p style={{
                    fontWeight: 'bold',
                    color: 'red'
                  }}>{itemsList[itemIndex]?.min_bundle_quantity || '1'}</p>
                </div>
              </div> */}
            </div>
          </div>
          <div className='box-info-overlay-wrapper'>
             <div className='title'>
              <div className='title-item'>
                <p>Print FNSKU Labels</p>
                {/* <p>(L2 x H2 x W4 x 4Ib)</p>  */}
              </div>
          </div>
            <div className={'fnsku-label-wrapper '}>
              <Input
                placeholder='Enter Qty'
								overlayClassName='enter-qty-field'
                value={fnskuLabels || ''}
                onChange={(e) => {
                  const value = e.target.value;
                  // Only allow integers (no decimals)
                  if (/^\d*$/.test(value)) {
                    setFnskuLabels(value);
                  }
                }}
              />
              <div className='buttons-wrapper' style={{
                marginLeft: '17px',
								display: 'flex',
								alignContent: 'center',
								justifyContent: 'center'
              }}>
                <Button
                  onClick={handlePrintFnskuLabels}
                  text="Print"
                  disabled={!fnskuLabels || Number(fnskuLabels) <= 0 || !Number(fnskuLabels)}
                />
              </div>
            </div>

            <div className='select-shipment-wrapper'>
              <p className='title-wrap'>Select Shipment</p>
              <div className="shipment-cards">
                {itemShipments.map((shipment, index) => (
                  <div
                    key={shipment.id}
                    style={Number((shipment.quantity || 0) - (shipment.boxed_quantity || 0)) ? {} : { display: 'none' }}
                    className={`shipment-card ${itemShipmentIndex === index ? "active" : ""}`}
                    onClick={() => {
                      setItemShipmentIndex(index);
                      setBoxesDetail([{ ...initialBoxDetails }]);

                      const itemIndex = findIndex(itemsList, ({ id }) => id === itemShipments[index]?.shipment_item_id);
                      const item = itemsList.find(({ id }) => id === itemShipments[index]?.shipment_item_id);
                      if (item) {
                        setProductDetail(item);
                      }
                      setItemIndex(itemIndex);
                    }}
                  >
                    <div className="items">
                      <p>Shipment ID:</p>
                      <p>{shipment.amazon_shipment_confirmation_id}</p>
                    </div>
                    <div className="items">
                      <p>Total Qty:</p>
                      <p>{shipment.quantity}</p>
                    </div>
                    <div className="items">
                      <p>Remaining Qty:</p>
                      <p>{shipment.quantity - (shipment.boxed_quantity || 0)}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className='title'>
              <div className='title-item'>
                <p>Box Information</p>
                {/* <p>(L2 x H2 x W4 x 4Ib)</p> */}
              </div>
              <Button
                onClick={addRow}
                text="Add New Box Config"
                disabled={ creatingSingleSkuBox ||  (itemShipmentIndex === -1)}
              />
            </div>
            <div className='input-boxes-overlay-wrapper'>
              {boxesDetail?.map((box, index) => (
                <div className={`input-boxes-wrapper ${boxesDetail.length > 1 ? 'increased' : ''}`} key={index}>
                  <Input
                    placeholder='Enter'
                    label={index === 0 ? "Number of Box" : ""}
                    value={box.noOfBoxes || ''}
                    onChange={(e) => {
                      const value = e.target.value;
                      // Only allow integers (no decimals)
                      if (/^\d*$/.test(value)) {
                        handleInputChange(index, 'noOfBoxes', value);
                      }
                    }}
                    disabled={itemShipmentIndex === -1}
                  />
                  <Input
                    placeholder='Enter'
                    label={index === 0 ? "In a Box" : ""}
                    value={box.inABox || ''}
                    onChange={(e) => {
                      const value = e.target.value;
                      // Only allow integers (no decimals)
                      if (/^\d*$/.test(value)) {
                        handleInputChange(index, 'inABox', value);
                      }
                    }}
                    disabled={itemShipmentIndex === -1}
                  />
                  <Input
                    label={index === 0 ? "Total Qty" : ""}
                    value={(box.noOfBoxes || 0) * (box.inABox || 0)}
                    disabled={true}
                  />
                  {
                    index !== 0 &&
                    <div className='date-picker-items'>
                      <Tooltip title='Delete'>
                        <img
                          src={DeleteIcon}
                          alt='DeleteIcon'
                          onClick={() => removeRow(index)}
                          style={{ cursor: "pointer" }}
                        />
                      </Tooltip>
                    </div>
                  }
                </div>
              ))}
            </div>
            <div className='label-print-wrapper'>
              <div className='buttons-wrapper'>
                <Button
                  onClick={handleCancel}
                  disabled={creatingSingleSkuBox}
                  text="Cancel" className="outlined" />
                <Button
                  text= { creatingSingleSkuBox ? 'Adding..' : "Print Box Label"} 
                  disabled={getCreateBtnDisabledStatus()}
                  onClick={() => handleSubmitBoxCreation()}
                />
              </div>
            </div>
          </div>
          </div>
          </div>
        </DrawerStyleWrapper>
    </Modal>
  )
}

export default AddItemDrawer;
